function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 82 94"
}, props), React.createElement("path", {
  d: "M56.994 92L80 87.277l-3.042-15.101a14.882 14.882 0 00-5.144-8.529c-1.69-1.38-3.401-2.266-5.037-2.622L53.776 57.28a2.815 2.815 0 01-.795-.372 2.804 2.804 0 01-1.23-2.001l-.604-5.102c3.951-3.57 5.304-6.747 5.518-11.28.061-6.641-2.76-15.397-2.76-15.397-.81-2.335-2.353-4.678-4.111-5.997-5.114-3.85-12.26-4.093-17.435-.31-1.827 1.334-3.455 3.76-4.265 6.307 0 0-2.813 8.756-2.759 15.397.214 4.525 1.567 7.71 5.518 11.28l-.596 5.102a2.803 2.803 0 01-1.23 2.001 3.04 3.04 0 01-.795.371L15.23 61.024c-1.636.357-3.348 1.244-5.045 2.623a14.882 14.882 0 00-5.144 8.529L2 87.277 25.006 92",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M52.484 56.484a20.807 20.807 0 01-22.953 0",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M41.004 75.565v12.053",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M41.004 69.887V63.89",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M41.004 2c7.59 0 15.546 4.192 18.726 11.235 1.399 3.1 1.972 6.504 2.362 9.878.558 4.76.802 9.286 3.103 13.577 1.674 3.13 4.25 5.337 8.316 5.822 0 0-4.968 8.453-15.783 6.61M41.004 2c-7.59 0-15.546 4.192-18.726 11.235-1.399 3.1-1.972 6.504-2.362 9.878-.558 4.76-.802 9.286-3.103 13.577-1.674 3.13-4.242 5.337-8.316 5.822 0 0 4.968 8.453 15.784 6.61",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
})));